// Human-readable labels for the raw domain states the employee screen used to
// show verbatim.

export const SHIFT_STATE = {
  scheduled: 'Смена запланирована',
  wake_up_pending: 'Подтверди, что проснулся',
  wake_up_escalated: 'Подтверди, что проснулся',
  wake_up_confirmed: 'Подъём подтверждён',
  ready_to_open: 'Погнали — открывай смену',
  opening: 'Открываем…',
  active: 'Ты на смене 🔥',
  handover_pending: 'Передача смены',
  closing: 'Закрываем…',
  closed: 'Смена закрыта',
  force_closed: 'Смену закрыл админ',
  missed: 'Смена пропущена',
  cancelled: 'Смена отменена',
};

export const TASK_STATE = {
  upcoming: 'ещё не время',
  available: 'можно выполнять',
  due_soon: 'скоро дедлайн',
  overdue: 'просрочена',
  completed: 'выполнена',
  blocked: 'заблокирована',
  skipped: 'пропущена',
  cancelled: 'отменена',
};

export const PHASE = { opening: 'Открытие', active: 'Смена', closing: 'Закрытие' };

export const shiftStateLabel = (status) => SHIFT_STATE[status] || status;
export const taskStateLabel = (status) => TASK_STATE[status] || status;

const TERMINAL = new Set(['closed', 'force_closed', 'missed', 'cancelled']);
export const isShiftTerminal = (status) => TERMINAL.has(status);

// The single primary action the shift offers right now, or null.
export function primaryAction(shift) {
  if (!shift) return null;
  if (['pending', 'escalated'].includes(shift.wakeUpStatus)) {
    return { key: 'wake', label: 'Я проснулся', path: '/commands/confirm-wake-up' };
  }
  if (shift.status === 'ready_to_open') {
    return { key: 'open', label: 'Открыть смену', path: '/commands/open-shift' };
  }
  return null;
}
